import {useEffect} from 'react'
import {BasicLayout} from '../../modules/Layouts/basicLayout'
import {useHistory, useLocation} from 'react-router-dom'
import {useDispatch} from 'react-redux'

import {facturacionClearAll} from '../../actions/facturacion/facturacionEmision.actions'
import PrivateRoute from '../../routes/PrivateRoute'
import GeneracionDocumento from './GeneracionDocumento.page'
import ResumenDocumento from './ResumenDocumento.page'
import { documentosConsultarCatalogos } from '../../actions/documentos/documentos.actions'
import DetalleDocumento from './DetalleDocumento.page'

const EmitirDocumentoIndex = () => {
  const history = useHistory()
  const location = useLocation()
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(documentosConsultarCatalogos())
    window.scroll(0, 0)
  }, [])

  useEffect(() => {
    window.scroll(0, 0)
    let url = location.pathname.toLowerCase()
    if (url.includes('/otros-documentos/emitir'))
      if (
        url === '/otros-documentos/emitir/formulario' 
        || url === '/otros-documentos/emitir/resumen'
        || url === '/otros-documentos/emitir/detalle'
      ) return
    history.push('/404')
  }, [location])

  return (
    <BasicLayout>
      <PrivateRoute exact path='/otros-documentos/emitir/formulario' component={GeneracionDocumento} />
      <PrivateRoute exact path='/otros-documentos/emitir/resumen' component={ResumenDocumento} />
      <PrivateRoute exact path='/otros-documentos/emitir/detalle' component={DetalleDocumento} />
    </BasicLayout>
  )
}

export default EmitirDocumentoIndex
